var map = {
	"./InfoImg.png": [
		65,
		7,
		149
	],
	"./InfoImg.webp": [
		66,
		7,
		30
	],
	"./Slide2.png": [
		67,
		7,
		150
	],
	"./awards.png": [
		68,
		7,
		151
	],
	"./awards.webp": [
		69,
		7,
		31
	],
	"./bii/ecommerce_01.png": [
		70,
		7,
		152
	],
	"./bii/ecommerce_01.webp": [
		71,
		7,
		32
	],
	"./bii/ecommerce_02.png": [
		72,
		7,
		153
	],
	"./bii/ecommerce_02.webp": [
		73,
		7,
		33
	],
	"./bii/ecommerce_03.png": [
		74,
		7,
		154
	],
	"./bii/ecommerce_03.webp": [
		75,
		7,
		34
	],
	"./bii/ecommerce_11.png": [
		76,
		7,
		155
	],
	"./bii/ecommerce_11.webp": [
		77,
		7,
		35
	],
	"./bii/ecommerce_12.png": [
		78,
		7,
		156
	],
	"./bii/ecommerce_12.webp": [
		79,
		7,
		36
	],
	"./bii/ecommerce_13.png": [
		80,
		7,
		157
	],
	"./bii/ecommerce_13.webp": [
		81,
		7,
		37
	],
	"./bii/ecommerce_14.png": [
		82,
		7,
		158
	],
	"./bii/ecommerce_14.webp": [
		83,
		7,
		38
	],
	"./bii/ecommerce_15.png": [
		84,
		7,
		159
	],
	"./bii/ecommerce_15.webp": [
		85,
		7,
		39
	],
	"./bii/ecommerce_16.png": [
		86,
		7,
		160
	],
	"./bii/ecommerce_16.webp": [
		87,
		7,
		40
	],
	"./bii/ecommerce_17.png": [
		88,
		7,
		161
	],
	"./bii/ecommerce_17.webp": [
		89,
		7,
		41
	],
	"./bii/ecommerce_18.png": [
		90,
		7,
		162
	],
	"./bii/ecommerce_18.webp": [
		91,
		7,
		42
	],
	"./bii/ecommerce_19.png": [
		92,
		7,
		163
	],
	"./bii/ecommerce_19.webp": [
		93,
		7,
		43
	],
	"./bii/ecommerce_20.png": [
		94,
		7,
		164
	],
	"./bii/ecommerce_20.webp": [
		95,
		7,
		44
	],
	"./bii/ecommerce_21.png": [
		96,
		7,
		165
	],
	"./bii/ecommerce_21.webp": [
		97,
		7,
		45
	],
	"./bii/ecommerce_22.png": [
		98,
		7,
		166
	],
	"./bii/ecommerce_22.webp": [
		99,
		7,
		46
	],
	"./bii/ecommerce_23.png": [
		100,
		7,
		167
	],
	"./bii/ecommerce_23.webp": [
		101,
		7,
		47
	],
	"./bii/ecommerce_25.png": [
		102,
		7,
		168
	],
	"./bii/ecommerce_25.webp": [
		103,
		7,
		48
	],
	"./bii/ecommerce_31.png": [
		104,
		7,
		169
	],
	"./bii/ecommerce_31.webp": [
		105,
		7,
		49
	],
	"./bii/ecommerce_32.png": [
		106,
		7,
		170
	],
	"./bii/ecommerce_32.webp": [
		107,
		7,
		50
	],
	"./bii/ecommerce_34.png": [
		108,
		7,
		171
	],
	"./bii/ecommerce_34.webp": [
		109,
		7,
		51
	],
	"./dm/default_01.png": [
		110,
		7,
		172
	],
	"./dm/default_01.webp": [
		111,
		7,
		52
	],
	"./dm/default_02.png": [
		112,
		7,
		173
	],
	"./dm/default_02.webp": [
		113,
		7,
		53
	],
	"./dm/default_03.png": [
		114,
		7,
		174
	],
	"./dm/default_03.webp": [
		115,
		7,
		54
	],
	"./dm/default_04.png": [
		116,
		7,
		175
	],
	"./dm/default_04.webp": [
		117,
		7,
		55
	],
	"./dm/default_05.png": [
		118,
		7,
		176
	],
	"./dm/default_05.webp": [
		119,
		7,
		56
	],
	"./dm/default_06.png": [
		120,
		7,
		177
	],
	"./dm/default_06.webp": [
		121,
		7,
		57
	],
	"./dm/default_07.png": [
		122,
		7,
		178
	],
	"./dm/default_07.webp": [
		123,
		7,
		58
	],
	"./dm/default_08.png": [
		124,
		7,
		179
	],
	"./dm/default_08.webp": [
		125,
		7,
		59
	],
	"./dm/default_09.png": [
		126,
		7,
		180
	],
	"./dm/default_09.webp": [
		127,
		7,
		60
	],
	"./dm/default_10.png": [
		128,
		7,
		181
	],
	"./dm/default_10.webp": [
		129,
		7,
		61
	],
	"./dm/default_11.png": [
		130,
		7,
		182
	],
	"./dm/default_11.webp": [
		131,
		7,
		62
	],
	"./dm/default_12.png": [
		132,
		7,
		183
	],
	"./dm/default_12.webp": [
		133,
		7,
		63
	],
	"./dm/default_13.png": [
		134,
		7,
		184
	],
	"./dm/default_13.webp": [
		135,
		7,
		64
	],
	"./dm/default_14.png": [
		136,
		7,
		185
	],
	"./dm/default_14.webp": [
		137,
		7,
		65
	],
	"./dm/default_15.png": [
		138,
		7,
		186
	],
	"./dm/default_15.webp": [
		139,
		7,
		66
	],
	"./dm/default_16.png": [
		140,
		7,
		187
	],
	"./dm/default_16.webp": [
		141,
		7,
		67
	],
	"./dm/default_17.png": [
		142,
		7,
		188
	],
	"./dm/default_17.webp": [
		143,
		7,
		68
	],
	"./dm/default_18.png": [
		144,
		7,
		189
	],
	"./dm/default_18.webp": [
		145,
		7,
		69
	],
	"./dm/default_19.png": [
		146,
		7,
		190
	],
	"./dm/default_19.webp": [
		147,
		7,
		70
	],
	"./dm/default_20.png": [
		148,
		7,
		191
	],
	"./dm/default_20.webp": [
		149,
		7,
		71
	],
	"./fonts/OpenSansCondensed-Light.ttf": [
		150,
		7,
		72
	],
	"./gelato.png": [
		151,
		7,
		192
	],
	"./gelato.webp": [
		152,
		7,
		73
	],
	"./ii/16-min.png": [
		153,
		7,
		193
	],
	"./ii/16-min.webp": [
		154,
		7,
		74
	],
	"./ii/17-min.png": [
		155,
		7,
		194
	],
	"./ii/17-min.webp": [
		156,
		7,
		75
	],
	"./ii/25-min.png": [
		157,
		7,
		195
	],
	"./ii/25-min.webp": [
		158,
		7,
		76
	],
	"./ii/3-min.png": [
		159,
		7,
		196
	],
	"./ii/3-min.webp": [
		160,
		7,
		77
	],
	"./ii/37-min.png": [
		161,
		7,
		197
	],
	"./ii/37-min.webp": [
		162,
		7,
		78
	],
	"./ii/39-min.png": [
		163,
		7,
		198
	],
	"./ii/39-min.webp": [
		164,
		7,
		79
	],
	"./ii/45-min.png": [
		165,
		7,
		199
	],
	"./ii/45-min.webp": [
		166,
		7,
		80
	],
	"./ii/46-min.png": [
		167,
		7,
		200
	],
	"./ii/46-min.webp": [
		168,
		7,
		81
	],
	"./ii/48-min.png": [
		169,
		7,
		201
	],
	"./ii/48-min.webp": [
		170,
		7,
		82
	],
	"./ii/49-min.png": [
		171,
		7,
		202
	],
	"./ii/49-min.webp": [
		172,
		7,
		83
	],
	"./ii/50-min.png": [
		173,
		7,
		203
	],
	"./ii/50-min.webp": [
		174,
		7,
		84
	],
	"./ii/56-min.png": [
		175,
		7,
		204
	],
	"./ii/56-min.webp": [
		176,
		7,
		85
	],
	"./ii/57-min.png": [
		177,
		7,
		205
	],
	"./ii/57-min.webp": [
		178,
		7,
		86
	],
	"./ii/58-min.png": [
		179,
		7,
		206
	],
	"./ii/58-min.webp": [
		180,
		7,
		87
	],
	"./ii/59-min.png": [
		181,
		7,
		207
	],
	"./ii/59-min.webp": [
		182,
		7,
		88
	],
	"./ii/6-min.png": [
		183,
		7,
		208
	],
	"./ii/6-min.webp": [
		184,
		7,
		89
	],
	"./ii/60-min.png": [
		185,
		7,
		209
	],
	"./ii/60-min.webp": [
		186,
		7,
		90
	],
	"./ii/61-min.png": [
		187,
		7,
		210
	],
	"./ii/61-min.webp": [
		188,
		7,
		91
	],
	"./ii/62-min.png": [
		189,
		7,
		211
	],
	"./ii/62-min.webp": [
		190,
		7,
		92
	],
	"./ii/63-min.png": [
		191,
		7,
		212
	],
	"./ii/63-min.webp": [
		192,
		7,
		93
	],
	"./ii/64-min.png": [
		193,
		7,
		213
	],
	"./ii/64-min.webp": [
		194,
		7,
		94
	],
	"./ii/65-min.png": [
		195,
		7,
		214
	],
	"./ii/65-min.webp": [
		196,
		7,
		95
	],
	"./ii/66-min.png": [
		197,
		7,
		215
	],
	"./ii/66-min.webp": [
		198,
		7,
		96
	],
	"./ii/67-min.png": [
		199,
		7,
		216
	],
	"./ii/67-min.webp": [
		200,
		7,
		97
	],
	"./ii/68-min.png": [
		201,
		7,
		217
	],
	"./ii/68-min.webp": [
		202,
		7,
		98
	],
	"./ii/69-min.png": [
		203,
		7,
		218
	],
	"./ii/69-min.webp": [
		204,
		7,
		99
	],
	"./ii/7-min.png": [
		205,
		7,
		219
	],
	"./ii/7-min.webp": [
		206,
		7,
		100
	],
	"./ii/70-min.png": [
		207,
		7,
		220
	],
	"./ii/70-min.webp": [
		208,
		7,
		101
	],
	"./ii/71-min.png": [
		209,
		7,
		221
	],
	"./ii/71-min.webp": [
		210,
		7,
		102
	],
	"./ii/72-min.png": [
		211,
		7,
		222
	],
	"./ii/72-min.webp": [
		212,
		7,
		103
	],
	"./ii/73-min.png": [
		213,
		7,
		223
	],
	"./ii/73-min.webp": [
		214,
		7,
		104
	],
	"./ii/74-min.png": [
		215,
		7,
		224
	],
	"./ii/74-min.webp": [
		216,
		7,
		105
	],
	"./ii/75-min.png": [
		217,
		7,
		225
	],
	"./ii/75-min.webp": [
		218,
		7,
		106
	],
	"./ii/76-min.png": [
		219,
		7,
		226
	],
	"./ii/76-min.webp": [
		220,
		7,
		107
	],
	"./ii/9-min.png": [
		221,
		7,
		227
	],
	"./ii/9-min.webp": [
		222,
		7,
		108
	],
	"./logo.png": [
		223,
		7,
		228
	],
	"./logo.webp": [
		224,
		7,
		109
	],
	"./partners/Burber.png": [
		225,
		7,
		229
	],
	"./partners/Burber.webp": [
		226,
		7,
		110
	],
	"./partners/Cosmopolit.png": [
		227,
		7,
		230
	],
	"./partners/Cosmopolit.webp": [
		228,
		7,
		111
	],
	"./partners/Eshak.png": [
		229,
		7,
		231
	],
	"./partners/Eshak.webp": [
		230,
		7,
		112
	],
	"./partners/GrandAdmiral.png": [
		231,
		7,
		232
	],
	"./partners/GrandAdmiral.webp": [
		232,
		7,
		113
	],
	"./partners/Hilton.png": [
		233,
		7,
		233
	],
	"./partners/Hilton.webp": [
		234,
		7,
		114
	],
	"./partners/KofeHauz.png": [
		235,
		7,
		234
	],
	"./partners/KofeHauz.webp": [
		236,
		7,
		115
	],
	"./partners/RadissonBlu.png": [
		237,
		7,
		235
	],
	"./partners/RadissonBlu.webp": [
		238,
		7,
		116
	],
	"./partners/barsuk.png": [
		239,
		7,
		236
	],
	"./partners/barsuk.webp": [
		240,
		7,
		117
	],
	"./partners/buddha.png": [
		241,
		7,
		237
	],
	"./partners/buddha.webp": [
		242,
		7,
		118
	],
	"./partners/felini.png": [
		243,
		7,
		238
	],
	"./partners/felini.webp": [
		244,
		7,
		119
	],
	"./partners/hyatt.png": [
		245,
		7,
		239
	],
	"./partners/hyatt.webp": [
		246,
		7,
		120
	],
	"./partners/il-molino.png": [
		247,
		7,
		240
	],
	"./partners/il-molino.webp": [
		248,
		7,
		121
	],
	"./partners/kanapa.png": [
		249,
		7,
		241
	],
	"./partners/kanapa.webp": [
		250,
		7,
		122
	],
	"./partners/osteriapantagruel.png": [
		251,
		7,
		242
	],
	"./partners/osteriapantagruel.webp": [
		252,
		7,
		123
	],
	"./partners/partnersSlide_ru": [
		31,
		3,
		4
	],
	"./partners/partnersSlide_ru.json": [
		31,
		3,
		4
	],
	"./partners/partnersSlide_ua": [
		32,
		3,
		5
	],
	"./partners/partnersSlide_ua.json": [
		32,
		3,
		5
	],
	"./partners/partnersSlide_uk": [
		33,
		3,
		6
	],
	"./partners/partnersSlide_uk.json": [
		33,
		3,
		6
	],
	"./partners/rishelie.png": [
		253,
		7,
		243
	],
	"./partners/rishelie.webp": [
		254,
		7,
		124
	],
	"./partners/shoti.png": [
		255,
		7,
		244
	],
	"./partners/shoti.webp": [
		256,
		7,
		125
	],
	"./partners/spaghetti.png": [
		257,
		7,
		245
	],
	"./partners/spaghetti.webp": [
		258,
		7,
		126
	],
	"./partners/sushiya.png": [
		259,
		7,
		246
	],
	"./partners/sushiya.webp": [
		260,
		7,
		127
	],
	"./partners/tequila.png": [
		261,
		7,
		247
	],
	"./partners/tequila.webp": [
		262,
		7,
		128
	],
	"./partners/vicini.png": [
		263,
		7,
		248
	],
	"./partners/vicini.webp": [
		264,
		7,
		129
	],
	"./partners/НellowSea.png": [
		265,
		7,
		249
	],
	"./partners/НellowSea.webp": [
		266,
		7,
		130
	],
	"./products/products_ru": [
		28,
		3,
		0
	],
	"./products/products_ru.json": [
		28,
		3,
		0
	],
	"./products/products_ua": [
		29,
		3,
		1
	],
	"./products/products_ua.json": [
		29,
		3,
		1
	],
	"./products/products_uk": [
		30,
		3,
		2
	],
	"./products/products_uk.json": [
		30,
		3,
		2
	],
	"./ru.png": [
		267,
		7,
		250
	],
	"./ru.webp": [
		268,
		7,
		131
	],
	"./slide1.png": [
		269,
		7,
		251
	],
	"./slide1.webp": [
		270,
		7,
		132
	],
	"./slide2.webp": [
		271,
		7,
		133
	],
	"./slide3.png": [
		272,
		7,
		252
	],
	"./slide3.webp": [
		273,
		7,
		134
	],
	"./slideImage/Slide2.png": [
		274,
		7,
		253
	],
	"./slideImage/Slide2.webp": [
		275,
		7,
		135
	],
	"./slideImage/Slide4.png": [
		276,
		7,
		254
	],
	"./slideImage/Slide4.webp": [
		277,
		7,
		136
	],
	"./slides/HomePageSlide_ru": [
		34,
		3,
		7
	],
	"./slides/HomePageSlide_ru.json": [
		34,
		3,
		7
	],
	"./slides/HomePageSlide_ua": [
		35,
		3,
		8
	],
	"./slides/HomePageSlide_ua.json": [
		35,
		3,
		8
	],
	"./slides/HomePageSlide_uk": [
		36,
		3,
		9
	],
	"./slides/HomePageSlide_uk.json": [
		36,
		3,
		9
	],
	"./social/hollow-cut-facebook.svg": [
		16,
		7
	],
	"./social/hollow-cut-google.svg": [
		278,
		7,
		137
	],
	"./social/hollow-cut-twitter.svg": [
		279,
		7,
		138
	],
	"./social/hollow-cut-youtube.svg": [
		17,
		7
	],
	"./social/zakaz.svg": [
		18,
		7
	],
	"./text/aboutUsText_ru": [
		37,
		3,
		10
	],
	"./text/aboutUsText_ru.json": [
		37,
		3,
		10
	],
	"./text/aboutUsText_ua": [
		38,
		3,
		11
	],
	"./text/aboutUsText_ua.json": [
		38,
		3,
		11
	],
	"./text/aboutUsText_uk": [
		39,
		3,
		12
	],
	"./text/aboutUsText_uk.json": [
		39,
		3,
		12
	],
	"./text/contactsText_ru": [
		40,
		3,
		13
	],
	"./text/contactsText_ru.json": [
		40,
		3,
		13
	],
	"./text/contactsText_ua": [
		41,
		3,
		14
	],
	"./text/contactsText_ua.json": [
		41,
		3,
		14
	],
	"./text/contactsText_uk": [
		42,
		3,
		15
	],
	"./text/contactsText_uk.json": [
		42,
		3,
		15
	],
	"./text/homeText_ru": [
		43,
		3,
		16
	],
	"./text/homeText_ru.json": [
		43,
		3,
		16
	],
	"./text/homeText_ua": [
		44,
		3,
		17
	],
	"./text/homeText_ua.json": [
		44,
		3,
		17
	],
	"./text/homeText_uk": [
		45,
		3,
		18
	],
	"./text/homeText_uk.json": [
		45,
		3,
		18
	],
	"./text/partnersText_ru": [
		46,
		3,
		19
	],
	"./text/partnersText_ru.json": [
		46,
		3,
		19
	],
	"./text/partnersText_ua": [
		47,
		3,
		20
	],
	"./text/partnersText_ua.json": [
		47,
		3,
		20
	],
	"./text/partnersText_uk": [
		48,
		3,
		21
	],
	"./text/partnersText_uk.json": [
		48,
		3,
		21
	],
	"./ua.png": [
		280,
		7,
		255
	],
	"./ua.webp": [
		281,
		7,
		139
	],
	"./uk.png": [
		282,
		7,
		256
	],
	"./uk.webp": [
		283,
		7,
		140
	],
	"./vp/1.png": [
		284,
		7,
		257
	],
	"./vp/1.webp": [
		285,
		7,
		141
	],
	"./vp/2.png": [
		286,
		7,
		258
	],
	"./vp/2.webp": [
		287,
		7,
		142
	],
	"./vp/3.png": [
		288,
		7,
		259
	],
	"./vp/3.webp": [
		289,
		7,
		143
	],
	"./vp/4.png": [
		290,
		7,
		260
	],
	"./vp/4.webp": [
		291,
		7,
		144
	],
	"./vp/5.png": [
		292,
		7,
		261
	],
	"./vp/5.webp": [
		293,
		7,
		145
	],
	"./vp/6.png": [
		294,
		7,
		262
	],
	"./vp/6.webp": [
		295,
		7,
		146
	],
	"./vp/7.png": [
		296,
		7,
		263
	],
	"./vp/7.webp": [
		297,
		7,
		147
	],
	"./vp/8.png": [
		298,
		7,
		264
	],
	"./vp/8.webp": [
		299,
		7,
		148
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 27;
module.exports = webpackAsyncContext;